import { TilemapEditsManager } from "../../GameMap/TilemapEditsManager";
import type { WamFile } from "../../GameMap/WamFile";
import { Command } from "../Command";

export class DeleteTileLayerCommand extends Command {
    protected wamFile: WamFile;

    constructor(
        wamFile: WamFile,
        protected readonly layerId: number,
        commandId?: string,
    ) {
        super(commandId);
        this.wamFile = wamFile;
    }

    public execute(): Promise<void> {
        const overlay = TilemapEditsManager.getOrCreateOverlay(this.wamFile.getWam());
        overlay.layerEdits.push({ action: "delete", layerId: this.layerId });
        return Promise.resolve();
    }
}
